<template>
  <modal :show="show" @onShow="$emit('onShow')" @onHide="$emit('onHide')">
    <div class="dialog-hd">
      <h4 class="dialog-title">{{title}}</h4>
    </div>
    <div class="dialog-bd">
      <div class="dialog-msg-container"><slot></slot></div>
    </div>
    <div class="dialog-ft">
      <a href="javascript:;" class="dialog-btn default" @click="onCancel">{{cancelText}}</a>
      <a href="javascript:;" class="dialog-btn primary" @click="onConfirm">{{confirmText}}</a>
    </div>
  </modal>
</template>

<script>
  import Modal from './modal'

  export default {
    components: {
      Modal
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      title: String,
      confirmText: {
        type: String,
        default: '确定'
      },
      cancelText: {
        type: String,
        default: '取消'
      }
    },
    methods: {
      onConfirm (ev) {
        this.$emit('onConfirm', ev)
      },
      onCancel (ev) {
        this.$emit('onCancel', ev)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// confirm.vue?9044a744